import cx from 'classnames'
import { useState } from 'react'

import Styles from '../Controls.module.scss'

import { useImageMenuContext } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'
import { useFocus } from '@react-aria/interactions'

import { Search } from 'blaze-ui/icons/32'

export const SearchBar = () => {
  const { searchTerm, setSearchTerm } = useImageMenuContext()
  const [isFocused, setIsFocused] = useState(false)
  const { focusProps } = useFocus({
    onFocusChange: (isFocused) => {
      setIsFocused(isFocused)
    },
  })

  return (
    <div className={cx(Styles.search, { [Styles.focused]: isFocused })}>
      <Search size={24} />
      <input
        {...focusProps}
        className={Styles.input}
        placeholder="Search for images and videos"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  )
}
